import {Button as SemanticButton} from 'semantic-ui-react';
import styled, {css} from 'styled-components';

const BtnMix = css`
    &.ui.button{
        border-radius: 5px;
        background-color: ${props => props.active ? '#c0c1c2' : '#f2f2f2'};
        box-shadow: 0 4px 0 0 rgba(0,0,0,0.3);
        width: 100%;
        font-family: Roboto, sans-serif;
        font-size: 1.15rem;
        font-weight: bold;
        letter-spacing: 1px;
        margin: .5rem 0;
        height: 52px;
        color: rgba(0, 0, 0, 0.6);
        touch-action: manipulation;
    }
    &.ui[class*="right labeled"].icon.button {
        padding-right: 2.5rem !important;
    }
    &.ui[class*="left labeled"].icon.button {
        padding-left: 2.5rem !important;
    }
    &.ui.labeled.icon.buttons > .button > .icon,
    &.ui.labeled.icon.button > .icon {
        background-color: transparent;
    }
`;

export const SmallBtnMix = css`
    &.ui.button{
        width: 60px;
        height: 32px;
        padding: 0;
    }
`;

export const ButtonsGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  & button:first-child {
    margin-right: .5rem !important;
  }
  & button:last-child {
    margin-left: .5rem !important;
  }
  & button:only-child {
      margin-left: 0 !important;
      margin-right: 0 !important;
  }
`;


export const DefaultButton = styled(SemanticButton)`${BtnMix};`;

export const GreenButton = styled(DefaultButton)`
    &.ui.button{
        background-color: #15C278;
        color: #ffffff;
    }
`;

export const NavyButton = styled(DefaultButton)`
    &.ui.button{
        background-color: #0353C7;
        color: #ffffff;
    }
`;

export const BlueButton = styled(DefaultButton)`
    &.ui.button{
        background-color: #009CDB;
        color: #ffffff;
    }
`;

export const LightBlueButton = styled(DefaultButton)`
    &.ui.button{
        background-color: #35CEED;
        color: #ffffff;
    }
`;

export const LinkButton = styled(DefaultButton)`
    &.ui.button{
        background-color: transparent;
        color: #ffffff;
        box-shadow: none;
    }
`;

export const SmallBlueButton = styled(BlueButton)`
    ${SmallBtnMix};
`;

export const SmallLightBlueButton = styled(LightBlueButton)`
    ${SmallBtnMix};
`;



// WEBPACK FOOTER //
// ./src/components/Button/ButtonMix.js